// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2cSW2","search":"Settings_search__1_Bbg","filter":"Settings_filter__1Eqqc"};